const regex = /\{([0-9a-zA-Z_]+)\}/g;

type StringTemplateValue = number | string | null | undefined;

export type StringTemplateValues = Record<string, StringTemplateValue>;

export function stringTemplate(string: string, values?: StringTemplateValues) {
  if (!values) {
    return string;
  }

  return string.replace(regex, (match, substring, offset) => {
    // Escape double brackets `{{value}}`
    if (string[offset - 1] === '{' && string[offset + match.length] === '}') {
      return substring;
    }

    if (values[substring] !== undefined && values[substring] !== null) {
      return values[substring];
    }

    return '';
  });
}
